import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=7b151186&scoped=true&"
import script from "./inspection.vue?vue&type=script&lang=js&"
export * from "./inspection.vue?vue&type=script&lang=js&"
import style0 from "./inspection.vue?vue&type=style&index=0&id=7b151186&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b151186",
  null
  
)

export default component.exports